module.exports = __webpack_public_path__ + "media/wo_chi_fan.f2935b4b.mp3";